import { VisualizerSettingsForm } from './visualizer-settings-form';

export const VisualizerSettingsContextModal = () => {
    return <VisualizerSettingsForm />;
};
